import * as SIPJS from '@livecaller/sip.js'
import LiveCaller from '../LiveCaller'

export default class SIP {
    constructor() {
        this.sipjs = SIPJS
        this.statuses = this.sipjs.Web.Simple.C
        this.remoteAudio = document.createElement('audio')
    }

    createSimple() {
        this.ua = new this.sipjs.UA(LiveCaller.config.get('sip.ua'))
        this.simple = new this.sipjs.Web.Simple({
            media: {
                remote: {
                    audio: this.remoteAudio,
                },
            },
            ua: this.ua,
        })
        this.simple.on('new', (...args) => {
            LiveCaller.$emit('sip.new', ...args)
        }).on('connected', (...args) => {
            LiveCaller.$emit('sip.connected', ...args)
        }).on('ended', (...args) => {
            LiveCaller.$emit('sip.ended', ...args)
        }).on('ringing', (...args) => {
            LiveCaller.$emit('sip.ringing', ...args)
        })
    }
}
